import React, { useState, useContext } from "react";
import { StateContext } from "../../../state";
import Button, { ButtonContainer } from '../../library/Buttons';
import StartOver from '../../library/StartOver';
import { substituteVariablesInString } from "../../../utils/substitutions";

export const BasicAcceptFlow = ({acceptPayment, children}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [{configuration, payment, paymentNetworkConfig}] = useContext(StateContext);
  const dataForVariableSubstitutions = {payment, paymentNetwork: paymentNetworkConfig};
  const label = substituteVariablesInString(configuration.acceptPayment.btnLabel, dataForVariableSubstitutions);

  const onSubmit = async () => {
    setIsFetching(true);
    await acceptPayment();
  };

  const View = children;

  return (
    <View
      onSubmit={onSubmit}
      isFetching={isFetching}
    >
      <ButtonContainer>
        <Button
          onClick={onSubmit}
          label={label}
          disabled={isFetching}
        />
      </ButtonContainer>
      <StartOver/>
    </View>
  );
};

export default BasicAcceptFlow;
